export enum PaymentType {
  Monthly = 'M',
  Annually = 'A',
}
